<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M13 9h5.5L13 3.5V9M6 2h8l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.11.89-2 2-2m0 18h12v-8l-4 4-2-2-6 6M8 9a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2z"/>
    </svg>
</template>

<script>
export default {
    name: 'FileImageIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
